var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C13.625 15 12.4479 14.5104 11.4688 13.5312C10.4896 12.5521 10 11.375 10 10C10 8.625 10.4896 7.44792 11.4688 6.46875C12.4479 5.48958 13.625 5 15 5C16.375 5 17.5521 5.48958 18.5312 6.46875C19.5104 7.44792 20 8.625 20 10C20 11.375 19.5104 12.5521 18.5312 13.5312C17.5521 14.5104 16.375 15 15 15ZM7.5 25C6.8125 25 6.22417 24.7554 5.735 24.2663C5.245 23.7763 5 23.1875 5 22.5V21.5C5 20.7917 5.1825 20.1404 5.5475 19.5463C5.91167 18.9529 6.39583 18.5 7 18.1875C8.29167 17.5417 9.60417 17.0571 10.9375 16.7338C12.2708 16.4113 13.625 16.25 15 16.25C16.375 16.25 17.7292 16.4113 19.0625 16.7338C20.3958 17.0571 21.7083 17.5417 23 18.1875C23.6042 18.5 24.0883 18.9529 24.4525 19.5463C24.8175 20.1404 25 20.7917 25 21.5V22.5C25 23.1875 24.7554 23.7763 24.2663 24.2663C23.7763 24.7554 23.1875 25 22.5 25H7.5Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/profileicon.4ec68995ebaa1fb6841484112bd510ce.svg";
export { ForwardRef as ReactComponent };